import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { ChipLinkList } from 'components';
import { ROUTE_PATH } from 'constants/routes';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

export const CustomersPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features',
  });

  const { isTechOperator } = useUser();
  const routes = useMemo(
    () => (isTechOperator ? ROUTE_PATH.TECH_OPERATOR : ROUTE_PATH.ADMIN),
    [isTechOperator],
  );

  return (
    <Outlet
      context={{
        headerSubcontent: (
          <ChipLinkList
            links={[
              {
                label: t('blocked_customers.title'),
                to: routes.BLOCKED_CUSTOMERS,
              },
              {
                label: t('trusted_customers.title'),
                to: routes.TRUSTED_CUSTOMERS,
              },
              {
                label: t('counterparties.title'),
                to: routes.COUNTERPARTIES,
              },
            ]}
          />
        ),
      }}
    />
  );
};
